import { createRouter, createWebHashHistory, Router } from 'vue-router'
import { baseRoutes } from './routes'
import useNavigator from '@/composables/useNavigator'

export class RouterSingleton {
    private static router: Router

    public static getRouter(): Router {
        if (!RouterSingleton.router) {
            RouterSingleton.router = createRouter({
                routes: baseRoutes,
                history: createWebHashHistory(),
                linkActiveClass: 'active',
            })

            RouterSingleton.router.beforeEach((to, from, next) => {
                const { scopedAuthGuard } = useNavigator()

                const requiredScopes = to.meta.requiredScopes
                if (requiredScopes) {
                    scopedAuthGuard(to, from, next, requiredScopes, 'Unauthorized')
                } else {
                    next()
                }
            })
        }
        return RouterSingleton.router
    }
}